import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f24f3b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { useVModel } from '@vueuse/core';
import { reactive, watch } from 'vue';
import { getHospitalList, findLastHospital, storeUserHospital, updateHospitalInfo } from '@/modules/medical/tool/hospital';
import { service as globalService, state as globalState } from '@/modules/global';
import { HospitalItem } from '@/@types/hospital';
import { usePermissionStore } from '@/modules/permission';

interface IProps {
  visible: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalList',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "confirm", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible');
  (e: 'confirm', value: HospitalItem);
  (e: 'cancel');
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
};

const { generateRoutes } = usePermissionStore();




const visible = useVModel(props, 'visible', emit);

const state = reactive({
  hospitalList: [] as HospitalItem[],
  /** 选择的医院id */
  hospitalId: 0,
  /** 选中的医院 */
  hospitalInfo: {} as HospitalItem,
  /** 上次登录的医院id */
  lastHospitalId: 0,
});

/** 获取最后一次医生所处的医院信息 */
const nowDocHospitalInfo = () => {
  const info = findLastHospital();
  state.hospitalInfo = { hospitalId: 0, hospitalName: '' };
  if (info && info.hospitalId) {
    state.lastHospitalId = info.hospitalId;
    state.hospitalInfo = info;
    state.hospitalId = info.hospitalId;
  } else {
    state.lastHospitalId = 0;
    state.hospitalId = 0;
  }
};

watch(
  () => props.visible,
  () => {
    state.hospitalList = getHospitalList();
    nowDocHospitalInfo();
  },
);

/** 选中医院的时候存储医院信息 */
const chooseHospital = (item: HospitalItem) => {
  state.hospitalId = item.hospitalId;
  state.hospitalInfo = item;
};

/** 确认选中医院并前往内部页面 */
const confirmHospital = () => {
  storeUserHospital(state.hospitalInfo);
  updateHospitalInfo();
  globalService.getUserInfo().then(() => {
    generateRoutes().then(() => {
      emit('confirm', state.hospitalInfo);
    });
  });
};
/** 取消选中医院 */
const cancelChoose = () => {
  visible.value = false;
  emit('cancel');
};

return (_ctx: any,_cache: any) => {
  const _component_check_outlined = _resolveComponent("check-outlined")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _unref(visible),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    title: "请选择医院",
    onCancel: cancelChoose,
    onOk: confirmHospital
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_list, {
        "item-layout": "horizontal",
        "data-source": state.hospitalList
      }, {
        renderItem: _withCtx(({ item }) => [
          _createVNode(_component_a_list_item, {
            class: "hospital-item-sty",
            onClick: ($event: any) => (chooseHospital(item))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_list_item_meta, null, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.hospitalName), 1),
                  (state.lastHospitalId === item.hospitalId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "（上次登录）"))
                    : _createCommentVNode("", true)
                ]),
                avatar: _withCtx(() => [
                  _createVNode(_component_check_outlined, {
                    style: _normalizeStyle({ color: state.hospitalId === item.hospitalId ? '' : 'transparent' })
                  }, null, 8, ["style"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})